function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg031Pakistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.017,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.003,
    style: {
      fill: "#496E2D"
    },
    width: 384,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M372.459,297.284c-31.577,22.816-75.671,15.714-98.488-15.863   c-22.817-31.578-15.714-75.673,15.863-98.488c9.845-7.113,20.907-11.319,32.163-12.781c-21.652-3.239-44.538,1.641-63.686,15.475   c-38.864,28.082-47.606,82.352-19.525,121.217c28.081,38.863,82.352,47.606,121.216,19.522   c19.148-13.834,30.966-34.029,34.689-55.605C389.769,280.987,382.304,290.169,372.459,297.284z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "371.107,169.19 388.895,188.359 412.622,177.369 399.886,200.208 417.672,219.379    392.014,214.324 379.278,237.164 376.157,211.2 350.5,206.145 374.228,195.154  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg031Pakistan);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMi4wMDYgNTEyLjAwNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyLjAwNiA1MTIuMDA2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHg9IjAuMDAzIiB5PSIwLjAxNyIgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTExLjk4OSIvPgo8cmVjdCB4PSIxMjguMDAzIiBzdHlsZT0iZmlsbDojNDk2RTJEOyIgd2lkdGg9IjM4NCIgaGVpZ2h0PSI1MTIiLz4KPGc+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRjBGMEYwOyIgZD0iTTM3Mi40NTksMjk3LjI4NGMtMzEuNTc3LDIyLjgxNi03NS42NzEsMTUuNzE0LTk4LjQ4OC0xNS44NjMgICBjLTIyLjgxNy0zMS41NzgtMTUuNzE0LTc1LjY3MywxNS44NjMtOTguNDg4YzkuODQ1LTcuMTEzLDIwLjkwNy0xMS4zMTksMzIuMTYzLTEyLjc4MWMtMjEuNjUyLTMuMjM5LTQ0LjUzOCwxLjY0MS02My42ODYsMTUuNDc1ICAgYy0zOC44NjQsMjguMDgyLTQ3LjYwNiw4Mi4zNTItMTkuNTI1LDEyMS4yMTdjMjguMDgxLDM4Ljg2Myw4Mi4zNTIsNDcuNjA2LDEyMS4yMTYsMTkuNTIyICAgYzE5LjE0OC0xMy44MzQsMzAuOTY2LTM0LjAyOSwzNC42ODktNTUuNjA1QzM4OS43NjksMjgwLjk4NywzODIuMzA0LDI5MC4xNjksMzcyLjQ1OSwyOTcuMjg0eiIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMzcxLjEwNywxNjkuMTkgMzg4Ljg5NSwxODguMzU5IDQxMi42MjIsMTc3LjM2OSAzOTkuODg2LDIwMC4yMDggNDE3LjY3MiwyMTkuMzc5ICAgIDM5Mi4wMTQsMjE0LjMyNCAzNzkuMjc4LDIzNy4xNjQgMzc2LjE1NywyMTEuMiAzNTAuNSwyMDYuMTQ1IDM3NC4yMjgsMTk1LjE1NCAgIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };